<ng-container *transloco="let t; read:'permit.details.logs'">
    <ng-container *ngIf="(logs$ | async) !== undefined">
        <div class="logs" *ngIf="logs$ | async as logs">
            <pmt-permit-logs-log-item *ngFor="let log of logs.permitLogs" [log]="log">
            </pmt-permit-logs-log-item>
        </div>
        <div class="no-logs" *ngIf="(logs$ | async)?.permitLogs.length <= 0">{{ t("noLogs") }}</div>
    </ng-container>
</ng-container>
